export default function Footer() {
  const scrollToSection = (id: string) => {
    const el = document.querySelector(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-950 text-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <span className="text-xl font-heading text-primary-400 mb-4 block">
              成全影院
            </span>
            <p className="text-sm text-white/60 leading-relaxed">
              高清画质流畅播放不卡顿蓝光画质，无广告干扰免费在线观看电影电视剧全集。成全影院致力于为每一位影迷提供最优质的在线观影体验。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-medium text-white mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {[
                { label: '首页', href: '#hero' },
                { label: '影视分类', href: '#index' },
                { label: '必看推荐', href: '#carousel' },
                { label: '影讯快报', href: '#updates' },
                { label: '热播榜单', href: '#ranking' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(link.href);
                    }}
                    className="text-sm text-white/60 hover:text-primary-400 cursor-pointer transition-colors duration-200 no-underline"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium text-white mb-4">内容分类</h3>
            <ul className="space-y-2.5">
              {['动作大片', '喜剧精选', '悬疑推理', '爱情文艺', '科幻巨制', '恐怖惊悚', '动漫番剧', '纪录纪实'].map((cat) => (
                <li key={cat}>
                  <a
                    href="#index"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection('#index');
                    }}
                    className="text-sm text-white/60 hover:text-primary-400 cursor-pointer transition-colors duration-200 no-underline"
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium text-white mb-4">合作伙伴</h3>
            <p className="text-sm text-white/40 leading-relaxed mb-4">
              成全影院与多家内容提供商和技术伙伴保持紧密合作，共同为用户打造卓越的在线观影生态。
            </p>
            <div className="flex gap-3">
              <a href="#features" onClick={(e) => { e.preventDefault(); scrollToSection('#features'); }} className="w-9 h-9 rounded-full bg-white/10 hover:bg-primary-500 flex items-center justify-center cursor-pointer transition-colors duration-200">
                <i className="ri-shield-check-line text-sm"></i>
              </a>
              <a href="#faq" onClick={(e) => { e.preventDefault(); scrollToSection('#faq'); }} className="w-9 h-9 rounded-full bg-white/10 hover:bg-primary-500 flex items-center justify-center cursor-pointer transition-colors duration-200">
                <i className="ri-question-line text-sm"></i>
              </a>
              <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('#contact'); }} className="w-9 h-9 rounded-full bg-white/10 hover:bg-primary-500 flex items-center justify-center cursor-pointer transition-colors duration-200">
                <i className="ri-mail-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            &copy; 2024-2026 成全影院 chengquan.tv - 高清画质流畅播放不卡顿蓝光画质 | 无广告干扰免费在线观看电影电视剧全集
          </p>
          <p className="text-xs text-white/30">
            本站内容仅供学习交流，请支持正版
          </p>
        </div>
      </div>
    </footer>
  );
}